<app-basic-form [form]="form" [keys]="keys"></app-basic-form>
<ng-container *ngIf="showFunds">
    <app-assets-table [assets]="assets" [form]="form" [tableKeys]="tableKeys" [isReadOnly]="isReadOnly"></app-assets-table>
</ng-container>